import React, { useEffect, useState, useCallback } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import * as app_consts from "../../../../../constants/react_app_consts";
import AdjustInventoryModel from "./warehouse_inventory_modal_data/AdjustInventoryModel";

const WarehouseInventoryModel = ({
  openModal,
  setOpenModal,
  type,
  modalTitle = "Adjust Inventory",
  modalDescription,
  succFunc, // legacy name (keep working)
  size,
  data,
  openOtherModalFunc,
  successFunction, // legacy/alternate name (keep working)
  onSuccess, // NEW: preferred callback from parent to refresh lists
}) => {
  const [modal, setModal] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [modal_type, setModalType] = useState(type);

  useEffect(() => {
    setModal(openModal);
    setModalType(type);
  }, [openModal, type]);

  const closeModal = useCallback(() => {
    if (modalLoading) return;
    setOpenModal(false);
  }, [modalLoading, setOpenModal]);

  // Backwards compatible success trigger:
  const handleSuccess = useCallback(
    (payload) => {
      // close first
      setOpenModal(false);

      // old callbacks (if used elsewhere)
      if (typeof succFunc === "function") succFunc(payload);
      if (typeof successFunction === "function") successFunction(payload);

      // new callback
      if (typeof onSuccess === "function") onSuccess(payload);
    },
    [setOpenModal, succFunc, successFunction, onSuccess]
  );

  return (
    <Modal
      isOpen={modal}
      className="modal-dialog-centered"
      size={size ? size : modal_type === app_consts.ADJUST_INVENTORY_MODAL ? "xl" : "lg"}
    >
      <ModalHeader toggle={!modalLoading ? closeModal : undefined}>
        {modalTitle}
      </ModalHeader>

      <ModalBody>
        {modal_type === app_consts.ADJUST_INVENTORY_MODAL ? (
          <AdjustInventoryModel
            data={data}                 // { warehouse_storage_id, product_id }
            modal={modal}
            modalDescription={modalDescription}
            setModalLoading={setModalLoading} // child controls loading
            onClose={closeModal}              // child can close modal
            onSuccess={handleSuccess}         // child calls after POST success
            openOtherModalFunc={openOtherModalFunc}
          />
        ) : (
          <></>
        )}
      </ModalBody>
    </Modal>
  );
};

export default WarehouseInventoryModel;
